/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type RatesAndInternalCostLitePage_company$ref: FragmentReference;
declare export opaque type RatesAndInternalCostLitePage_company$fragmentType: RatesAndInternalCostLitePage_company$ref;
export type RatesAndInternalCostLitePage_company = {|
  +id: string,
  +currency: ?string,
  +$refType: RatesAndInternalCostLitePage_company$ref,
|};
export type RatesAndInternalCostLitePage_company$data = RatesAndInternalCostLitePage_company;
export type RatesAndInternalCostLitePage_company$key = {
  +$data?: RatesAndInternalCostLitePage_company$data,
  +$fragmentRefs: RatesAndInternalCostLitePage_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RatesAndInternalCostLitePage_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company"
};
// prettier-ignore
(node/*: any*/).hash = '53fe65a4967f3cea68719b3ff09f1710';

module.exports = node;
